// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "startSearch-Ufhdb";
var _5 = "startSearch_multiCity-3BNcE";
var _6 = "quickSearch__form-3GEjT";
var _7 = "startSearch_iconMode-25Fjg";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "mobile", _4 as "startSearch", _5 as "startSearch_multiCity", _6 as "quickSearch__form", _7 as "startSearch_iconMode" }
export default { "__esModule": _1, "tablet_only": _2, "mobile": _3, "startSearch": _4, "startSearch_multiCity": _5, "quickSearch__form": _6, "startSearch_iconMode": _7 }
